import { render, staticRenderFns } from "./ProductSetProductTile.vue?vue&type=template&id=b5c8f3d4"
import script from "./ProductSetProductTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSetProductTile.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CreatorShopTile: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/CreatorShopTile.vue').default,SplitTest: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/SplitTest.vue').default})
